import { useMemo } from 'react';
import type { JSX } from 'react';

import { parseHtml } from '@change-corgi/core-react/html';
import type { ParseHtmlOptions } from '@change-corgi/core-react/html';

import { createAnchorToLinkReplacer } from '#src/shared/ds';

type Props = Readonly<{
	html: string;
	/**
	 * called when any link in the html is clicked
	 */
	onLinkClick?: () => void;
	options?: Omit<ParseHtmlOptions, 'replace'>;
}>;

/**
 * Renders simple, non-i18n HTML (e.g. server-provided messages), with any <a> rendered as the design-system Link,
 * like translated copy
 *
 * For translated copy, use `TranslateHtml`/`translateHtml`, which already do this
 */
export function SimpleHtml({ html, onLinkClick, options }: Props): JSX.Element {
	const replace = useMemo(() => createAnchorToLinkReplacer({ onClick: onLinkClick }), [onLinkClick]);

	return <>{parseHtml(html, { ...options, replace })}</>;
}
